
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/sea-burial/[id]",
      function () {
        return require("private-next-pages/facilities/sea-burial/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/sea-burial/[id]"])
      });
    }
  